import React, { useEffect, useState } from 'react';
import oktoberfest from "../../assets/icon/oktoberfest.gif";
import * as util from "../../utils/util";
import api from "../../utils/api";

import Bottom from "../Bottom";
import { Box, Button, Grid, Typography } from "@mui/material";
import Top from "../Top";
import Circle from "../../components/CircleProgress";
import BarChart from "../../components/BarChart";
import HistorySliderInput from "../../components/HistorySliderInput";
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';



const params = {
  token: '',
  from: '',
  to: '',
  target: ''
}

const initTargetMoisture = {
  moisture: 0,
  target_moisture: 0
}

const HistoryBurnKcal = () => {
  const [targetDate, setTargetDate] = React.useState('');
  const [targetMoisture, setTargetMoisture] = React.useState(initTargetMoisture);
  const [series, setSeries] = React.useState([
    { dataKey: 'moisture', label: '수분섭취량', valueFormatter: (value: number | null) => `${value}mm`, stack: 'total' }
  ]);
  const [dataset, setDataset] = React.useState([{ target: 0, moisture: 0, month: '' }]);
  const [dayValue, setDayValue] = useState(0);

  useEffect(() => {
    setMoistureData();
    
    
    api.get(`app/api/v1/AP_002_013?type=meal&month=7`).then(res => {
      console.log(res)
    }).catch(function (error) {
      console.log(error)
    });
    
  }, [dayValue]);

  function setMoistureData() {
    // 수분섭취 정보 조회
    params.token = localStorage.getItem('token') || '';
    params.from = util.getDateByCustom('yyyyMMdd', dayValue - 7);
    params.to = util.getDateByCustom('yyyyMMdd', dayValue);
    params.target = util.getDateByCustom('yyyyMMdd', dayValue);

    api.get(`app/api/v1/AP_002_004?token=${params.token}&from=${params.from}&to=${params.to}&target=${params.target}`).then(res => {
      if (res.data.result_code === '0') {
        setTargetDate(params.target);
        setTargetMoisture(res.data.result_data.target);
        setSeries(series);
        let tempArr = [];
        for (let item of res.data.result_data.data.moisture_v2) {
          let obj = { target: 0, moisture: 0, month: '' };
          obj.month = item.date;
          obj.moisture = item.moisture;
          tempArr.push(obj);
        }
        setDataset(tempArr.reverse());
      }
    }).catch(function (error) {
      console.log(error)
    });
  }

  // 수분섭취 저장
  function saveMoisture(value: any) {
    const saveParams = { date: '', moisture: '' };
    saveParams.date = targetDate.slice(0, 4) + '-' + targetDate.slice(4, 6) + '-' + targetDate.slice(6, 8);
    saveParams.moisture = value;

    api.post(`app/api/v1/AP_002_008`, saveParams).then(res => {
      setMoistureData();
    }).catch(function (error) {
      console.log(error)
    });
  }

  // 목표 수분섭취 저장
  function saveTargetMoisture(value: any) {
    const saveParams = { date: '', targetMoisture: '' };
    saveParams.date = targetDate.slice(0, 4) + '-' + targetDate.slice(4, 6) + '-' + targetDate.slice(6, 8);
    saveParams.targetMoisture = value;

    api.post(`app/api/v1/AP_002_011`, saveParams).then(res => {
      setMoistureData();
    }).catch(function (error) {
      console.log(error)
    });
  }



  return (
    <Stack sx={{ width: '100%', minWidth: 320, background: '#F1F2F4', pb: 12, pl: 2, pr: 2, boxSizing: 'border-box' }} spacing={6}>
      <Top title="수분 기록" />

      <Grid sx={{ bgcolor: '#F1F2F4', p: 0, width: '100%', minHeight: 500 }}>
        <Box>
          <Typography component="div" sx={{ fontSize: 20, color: '#555', m: 4, mb: 0, textAlign: 'center', fontWeight: 700 }}>
            <ArrowLeftIcon onClick={() => setDayValue((prev) => prev - 1)} sx={{ verticalAlign: 'text-bottom' }} />
            {targetDate.slice(0, 4) + '.' + targetDate.slice(4, 6) + '.' + targetDate.slice(6, 8)}
            <ArrowRightIcon onClick={() => setDayValue((prev) => prev + 1)} sx={{ 'display': dayValue < 0 ? 'inline-block' : 'none', verticalAlign: 'text-bottom' }} />
          </Typography>

          <Stack direction={'row'} justifyContent={'center'} sx={{ m: '20px 0', p: 1, bgcolor: '#fff', borderRadius: '15px', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Grid sx={{
              '& .CircleChart .MuiGauge-root': { width: '130px', height: '130px' },
              '& .CircleChart .circleText': { fontSize: 24, },
              '& .MuiGauge-valueArc': {
                fill: '#33cccc !important',
              },
            }}>
              <Circle progress={{ goal: targetMoisture.target_moisture, value: targetMoisture.moisture }} />
            </Grid>

            <Stack justifyContent={'center'} sx={{ m: 'auto', }}>
              <Avatar alt="" src={oktoberfest} sx={{ m: 'auto', width: '60px', height: '60px', borderRadius: 0 }} />
            </Stack>

            <Stack direction={'row'} alignItems={'center'} sx={{ ml: 'auto', mr: 2 }}>
              <Stack direction={'column'} sx={{ ml: 'auto' }}>
                <Typography component="div" sx={{ fontSize: 35, color: '#33cccc', fontWeight: 700 }}>
                  {util.formatComma(targetMoisture.moisture)}
                </Typography>
                <Typography component="span" sx={{ fontSize: 20, color: '#999', mb: 0, textAlign: 'right' }}>
                  {util.formatComma(targetMoisture.target_moisture)}
                </Typography>
              </Stack>

              <Typography component="div" sx={{ fontSize: 18, color: '#777', ml: 1, mb: 2 }}>
                cup
              </Typography>
            </Stack>
          </Stack>

          <Grid container justifyContent="center" alignItems="center" >
            <HistorySliderInput info={{ value: targetMoisture.moisture, title: '오늘의 수분 섭취량을 입력하세요', unit: 'cup', btnTitle: '입력 하기', max: 50 }} handleComplete={saveMoisture} />
            <HistorySliderInput info={{ value: targetMoisture.target_moisture, title: '오늘의 목표 수분 섭취량을 입력하세요', unit: 'cup', btnTitle: '목표 설정', max: 50 }} handleComplete={saveTargetMoisture} />
          </Grid>

          <Box sx={{ bgcolor: '#fff', p: '0 10px 10px 10px', borderRadius: '15px', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ p: 1 }}>
              <Stack >
                <Typography component="div" sx={{ fontSize: 12, color: '#999', }}>최근 7일</Typography>
              </Stack>
              <Stack sx={{ ml: 'auto', zIndex: 2  }} >
                <Button  sx={{fontSize:12, color:'#555', }} endIcon={<ArrowRightIcon />} >
                월간현황
                </Button>
              </Stack>
            </Stack>
            <Divider />
            <Box sx={{
              mt: -3.5,
              '& .MuiBarElement-root': { fill: '#33cccc' },
              '& .MuiChartsLegend-mark': { fill: '#33cccc' }
            }}>
              <BarChart dataset={dataset}
                chartSetting={chartSet}
                series={series}
              />
            </Box>
          </Box>
        </Box>
      </Grid>

      <Bottom />
    </Stack>
  );
}

/*
const EditButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight:700,
  padding: '6px 20px',
  lineHeight: 1.5,
  backgroundColor: '#fff',
  border:'1px solid #EF8322',
  borderRadius:'20px',
  color:'#EF8322',
  margin:'10px 0 30px 0',
  width:'47%',
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color:'#fff'
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});
*/

const chartSet = {
  xAxis: [
    {
      label: '',
    },
  ],
  maxWidth: 450,
  height: 300,
  slotProps: {
    legend: {
      direction: 'row',
      position: { vertical: 'bottom', horizontal: 'middle' },
      padding: -5,
      itemMarkWidth: 10,
      itemMarkHeight: 10,
      labelStyle: {
        fontSize: 12,
      },
    },
  },
};

export default HistoryBurnKcal;